import type { UseFloatingOptions } from '@floating-ui/react';
import { autoUpdate, flip, offset, shift, useFloating, useHover, useInteractions } from '@floating-ui/react';
import { useState } from 'react';

type UseTooltipOptions = Partial<UseFloatingOptions> & { offset?: number };

export function useTooltip(props?: UseTooltipOptions) {
  const [open, setOpen] = useState(false);
  const { offset: offsetValue, ...floatingProps } = props ?? {};

  const { refs, floatingStyles, context, placement } = useFloating({
    open,
    onOpenChange: setOpen,
    middleware: [offset(offsetValue ?? 6), flip(), shift()],
    whileElementsMounted: autoUpdate,
    ...floatingProps,
  });

  const hover = useHover(context, {
    move: true,
    restMs: 80,
  });

  const { getReferenceProps, getFloatingProps } = useInteractions([hover]);

  return {
    refs,
    floatingStyles,
    open,
    setOpen,
    getReferenceProps,
    getFloatingProps,
    placement,
  };
}
